import { useEffect, useMemo } from 'react';
import UseContext from 'hooks/useContext';
import { groupPerimeterNamesByMember } from 'components/perimeter/perimeterMembers';
import { PERIMETERS_CHANGED } from 'components/perimeter/perimeterUsage';
import SlideOverCompanyMembers from './slideOverCompanyMembers';
import SlideOverCompanyPerimeters from './SlideOverCompanyPerimeters';

// The perimeters (useCompanyPerimeters, read by the panel) serve the whole
// tab: the members list shows each member's perimeters, the perimeters block
// manages them, the contact screen edits a member's. No dedicated route gives
// a member's perimeters: they come from the members of each active perimeter.
const SlideOverCompanyContactsTab = ({
  companyInfo,
  setCompanyInfo,
  onEditMember,
  perimeters,
}) => {
  const { modalDataReturn, setModalDataReturn } = UseContext();
  const { reload } = perimeters;

  useEffect(() => {
    const type = modalDataReturn?.type;
    if (type === PERIMETERS_CHANGED) {
      setModalDataReturn({});
      reload();
    }
    // A member who joins or leaves changes who can be attached to a
    // perimeter: the members list consumes these returns, the perimeters are
    // only read again.
    if (type === 'employee_created' || type === 'employee_deleted') reload();
  }, [modalDataReturn, setModalDataReturn, reload]);

  // Until the list is in, a member's perimeters are unknown: nothing is shown
  // rather than a false « Toutes les missions ».
  const perimeterNamesByMember = useMemo(
    () =>
      perimeters.status === 'ready'
        ? groupPerimeterNamesByMember(perimeters.active)
        : null,
    [perimeters.status, perimeters.active],
  );

  return (
    <>
      <SlideOverCompanyMembers
        companyInfo={companyInfo}
        setCompanyInfo={setCompanyInfo}
        onEditMember={onEditMember}
        perimeterNamesByMember={perimeterNamesByMember}
      />
      <SlideOverCompanyPerimeters
        companyInfo={companyInfo}
        perimeters={perimeters}
      />
    </>
  );
};

export default SlideOverCompanyContactsTab;
